export default __webpack_public_path__ + "static/media/ic_cross.bc3b5027.svg";